angular.module('gym.components').directive('memberLoginDetails', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/member_login_details.html.slim'),
    scope: {
      contact: '=',
      form: '='
    },
    controller: ["$scope", "$rootScope", "$timeout", "$modal", "flash", "FreeTrialRemindMessageText", function($scope, $rootScope, $timeout, $modal, flash, FreeTrialRemindMessageText) {
      var save;
      $scope.loginUrl = `${$scope.contact.member_portal_details.login_url}`;
      $scope.onCopied = function() {
        $scope.copied = true;
        $timeout(function() {
          return $scope.copied = false;
        }, 2000);
        return true;
      };
      save = function() {
        if ($scope.contact.member_portal_details.enabled) {
          return $scope.contact.doPOST({}, 'enable_member_portal_detail');
        } else {
          return $scope.contact.doPOST({}, 'disable_member_portal_detail');
        }
      };
      $scope.onToggleChange = function() {
        return save().then(function() {
          return flash.success = 'Member Portal Login Details saved';
        }, function() {
          flash.error = 'Unable to update Member Portal Login Details';
          return $scope.contact.member_portal_details.enabled = !$scope.contact.member_portal_details.enabled;
        });
      };
      $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
      $scope.sendMemberDetails = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/resend_member_login_details.html.slim'),
          size: 'md',
          resolve: {
            contact: function() {
              return $scope.contact;
            }
          },
          controller: 'MemberLoginDetailsModalCtrl'
        });
        return modalInstance.result.then(function() {
          return flash.success = 'Login details sent successfully';
        });
      };
      $scope.message = FreeTrialRemindMessageText.getMessage('Growing');
      $scope.isReminderMessageShown = false;
      $scope.isPayor = window.currentUser.account_owner;
      return $scope.togglePopover = function(event) {
        $scope.left = event.target.offsetLeft + 250;
        $scope.top = event.target.offsetTop - 100;
        if (event) {
          return $scope.isReminderMessageShown = !$scope.isReminderMessageShown;
        }
      };
    }]
  };
});
